import * as React from 'react';
import {
  ISharingLink, SharingLinkKind
} from '../../../interfaces/SharingInterfaces';
import { IPerson } from '@ms/odsp-datasources/lib/PeoplePicker';
import { Persona, PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { autobind } from 'office-ui-fabric-react/lib/Utilities';
import { ConfirmationDialog, ConfirmationCode } from '../ShareLink/ConfirmationDialog/ConfirmationDialog';
import stringsResx from '../../Share.resx';
import * as StringHelper from '@ms/odsp-utilities/lib/string/StringHelper';
export interface IShareLinkParticipantsProps {
  link: ISharingLink;
  showDetailsPanel: boolean;
  participants: IPerson[];
  updateLinkSettings: (inviteeToRemove: IPerson) => void;
  onRemoveParticipant?: (participantToRemove: IPerson, currentParticipants: Array<IPerson>) => void;
}

export interface IShareLinkParticipantsState {
  participant?: IPerson;
  participants?: IPerson[];
  showConfirmationDialog: boolean;
  confirmationCode: ConfirmationCode;
  hasPeopleChange: boolean;
}
export class ShareLinkParticipants extends React.Component<IShareLinkParticipantsProps, IShareLinkParticipantsState> {

  constructor(props: IShareLinkParticipantsProps, context: any) {
    super(props);

    this.state = {
      participants: this.props.participants,
      showConfirmationDialog: false,
      confirmationCode: ConfirmationCode.none,
      hasPeopleChange: false
    };
  }

  public render(): React.ReactElement<{}> {
    return (
      <ul className='od-ShareLink-participants' key={ !this.props.showDetailsPanel ? this.props.link.shareId : 'Panel-ul-' + this.props.link.shareId }>
        { this.props.participants.map(participant => {
          return (
            <li className='od-ShareLink-personaItem' key={ !this.props.showDetailsPanel ? participant.email : 'Panel-li-' + participant.email }>
              <Persona
                imageUrl={ participant.image }
                primaryText={ participant.name }
                secondaryText={ participant.isExternal ? stringsResx.externalUser : participant.job }
                size={ PersonaSize.size32 }
                showSecondaryText={ participant.job || participant.isExternal ? true : false }
              />
              { this.props.link.sharingLinkKind === SharingLinkKind.flexible &&
                <IconButton
                  data-is-focusable={ true }
                  ariaLabel={ StringHelper.format(stringsResx.removePersonLabel, participant.name) }
                  className='od-ShareLink-actionButton'
                  iconProps={ { iconName: 'Cancel' } }
                  onClick={ () => this.setState({
                    showConfirmationDialog: true,
                    confirmationCode: ConfirmationCode.participant,
                    participant: participant,
                  }) }
                />
              }
            </li>
          );
        }) }
        { this.state.showConfirmationDialog && this._renderConfirmationDialog() }
      </ul>
    );
  }

  private _renderConfirmationDialog() {
    const { confirmationCode, participants, participant } = this.state;

    return (
      <ConfirmationDialog
        confirmationCode={ confirmationCode }
        participants={ participants }
        participant={ participant }
        onApply={ this._onConfirmationDeleteParticipant }
        onCancel={ this.state.confirmationCode === ConfirmationCode.back ?
          this._onCancel
          :
          () => {
            this.setState({
              showConfirmationDialog: false,
              confirmationCode: ConfirmationCode.none,
            });
          } }
      />
    );
  }

  @autobind
  private _onCancel() {
    this.setState(() => {
      return {
        ...this.state,
        showDetailsPanel: false,
        showConfirmationDialog: false,
        participants: this.state.participants,
        hasPeopleChange: false,
      };
    });
  }

  @autobind
  private _onConfirmationDeleteParticipant() {
    if (this.state.confirmationCode === ConfirmationCode.participant) {
      this._onLinkParticipantDelete();
      this.setState({
        showConfirmationDialog: false,
        confirmationCode: ConfirmationCode.none,
      });
    }
    return;
  }

  @autobind
  private _onLinkParticipantDelete(): void {
    const participantToRemove = this.state.participant;
    let currentParticipants = [];
    if (!this.props.showDetailsPanel) {
      this.props.updateLinkSettings(participantToRemove);
    } else {
      if (participantToRemove.isExternal === true || !participantToRemove.principalName) {
        currentParticipants = this.props.participants.filter(participant => participant.email !== participantToRemove.email);
      } else {
        currentParticipants = this.props.participants.filter(participant => participant.principalName !== participantToRemove.principalName);
      }

      this.setState({
        ...this.state,
        participants: currentParticipants,
        hasPeopleChange: true,
      });

      this.props.onRemoveParticipant(participantToRemove, currentParticipants);
    }
  }
}